import { useEffect, useRef, useContext } from "react";
import { AppContext } from "src/context";
import { notification } from "antd";
import BackgroundNotification from "src/common/utils/notification";
import coreFunctions from "src/common/utils/coreFunctions";
import { syncPermissions } from "src/common/utils/permission";

const RealTime = ({
  setHasInternet,
}: {
  setHasInternet: (hasInternet: boolean) => void;
}) => {
  const [api] = notification.useNotification();
  const { dispatch } = useContext(AppContext);

  const isCheckingConnection = useRef(false);
  const NOTIFICATION = useRef(new BackgroundNotification());

  const checkInternetConnection = async () => {
    if (isCheckingConnection.current) return;
    isCheckingConnection.current = true;
    try {
      const result = await coreFunctions.hasInternetConnection();
      setHasInternet(result);
    } catch (err) {
      console.error("Connection check failed:", err);
    } finally {
      isCheckingConnection.current = false;
    }
  };

  useEffect(() => {
    const toastInterval = setInterval(() => {
      const toastItem = localStorage.getItem("toast");
      if (toastItem) {
        api.info({ ...JSON.parse(toastItem) });
        localStorage.removeItem("toast");
      }
    }, 500);

    const notificationInterval = setInterval(() => {
      if (localStorage.getItem("token") && !localStorage.getItem("waiting")) {
        NOTIFICATION.current.syncNotification();
        dispatch({ type: "TRIGGER_NOTIFICATION" });
      }
    }, 10000);

    const tokenCheckInterval = setInterval(() => {
      if (!localStorage.getItem("waiting")) {
        if (localStorage.getItem("token")) {
          coreFunctions.isTokenExpiredRedirect();
        } else {
          coreFunctions.forceRedirect();
        }
      }
    }, 1000);

    const connectionCheckInterval = setInterval(checkInternetConnection, 5000);

    const permissionSyncInterval = setInterval(() => {
      if (!localStorage.getItem("waiting") && localStorage.getItem("token")) {
        syncPermissions();
      }
    }, 10000);

    return () => {
      clearInterval(toastInterval);
      clearInterval(notificationInterval);
      clearInterval(tokenCheckInterval);
      clearInterval(connectionCheckInterval);
      clearInterval(permissionSyncInterval);
    };
  }, [api, dispatch]);

  return null;
};

export default RealTime;
